export default __webpack_public_path__ + "static/media/02_B.5be1e7d6.png";